<template>
  <div v-if="(!hasPosted.evaluation || !hasPosted.comment_text) && commentFlg && loaded">
    <div class="contentSeparator_gray" v-if="!is_digi"></div>
    <h3 class="u-mg-t-3 u-mg-b-3 caption">いかがでしたか？
      <br>よろしければ感想をお聞かせください
    </h3>
    <div class="comment-content">
      <hr class="gray-line" v-if="!is_digi">
      <!-- 満足度 -->
      <label class="formLabel u-mg-t-2" v-if="!is_digi">満足度</label>
      <!-- 商品がログインユーザーに該当する場合 -->
      <div class="evaluationSelect u-mg-t-2 u-mg-b-3">
        <div
          class="evaluationSelect__item"
          :data-selected="isSelected(option)"
          @click="selectStar(option)"
          v-for="option in evaluationOptions"
          :key="option.value"
        >
          <span>{{ option.label }}</span>
        </div>
      </div>

      <hr class="gray-line" v-if="!is_digi">
      <!-- 占い師へのメッセージ -->
      <label class="formLabel u-mg-t-2" v-if="!is_digi">占い師へのメッセージ</label>
      <div class="formGroup u-mg-t-2">
        <textarea
          class="formControl comment-text"
          v-model="comment_text"
          name="comment_text"
          :placeholder="is_digi ? '1000文字以内でご入力ください' : '例) 気になっている彼との今後について教えてくださってありがとうございました。タロットの説明もわかりやすく、とても参考になりました。'"
          rows="5"
          :class="{'error': errors.has('comment_text')}"
          v-validate="{ rules: {
          required: false,
          max: 1000
          } }"
        ></textarea>
        <p class="notice" v-if="is_digi">ご入力いただいた内容はサイトに掲載する場合がございます。個人が特定できる情報等は記載しないようにお願いします。</p>
        <p
          class="notice"
          v-if="!is_digi"
        >満足度と占い師へのメッセージはサイトに掲載する場合がございます。個人が特定できる情報等は記載しないようにお願いします。</p>
        <p class="formGroup__errorMessage">{{ errors.first('comment_text') }}</p>
      </div>

      <div class="u-flexRow u-justify-center">
        <button
          class="btn"
          data-color="brand"
          data-size="blodk"
          :data-disabled="isDisabled"
          style="width: 204px"
          @click="handleSubmit"
        >送信する</button>
      </div>
    </div>
  </div>
</template>

<script>
const evaluationOptions = [{ label: '大満足', value: 3 }, { label: '満足', value: 2 }, { label: '普通', value: 1 }];

export default {
  name: 'comment-input',
  props: {
    orderId: Number,
    commentFlg: Boolean,
    required: true,
    is_digi: false,
    kaonashiFlg: false
  },
  data() {
    return {
      hasPosted: {
        evaluation: false,
        comment_text: false
      },
      evaluation: undefined,
      comment_text: '',
      evaluationOptions,
      loaded: false
    };
  },
  created() {
    // APIからコメント取得
    axios
      .get('/api/comments', {
        params: { order_id: this.orderId }
      })
      .then(res => {
        let data = res.data.data[0];
        if (data) {
          this.evaluation = data.evaluation;
          this.comment_text = data.comment_text;
          this.hasPosted.evaluation = !!data.evaluation;
          this.hasPosted.comment_text = !!data.comment_text;
        }
        this.loaded = true;
      });
  },
  computed: {
    isDisabled() {
      var commentError = !this.errors.has('comment_text');
      return !((this.evaluation && commentError) || (this.comment_text && commentError));
    },
    mapEvaluation() {
      return this.evaluationOptions.find(option => option.value === this.evaluation).label;
    },
    postData() {
      return {
        order_id: this.orderId,
        comment_text: this.comment_text,
        evaluation: this.evaluation
      };
    }
  },
  methods: {
    nl2br(string) {
      return string.replace(/\n/g, '<br>');
    },
    selectStar(item) {
      this.evaluation = item.value;
    },
    isSelected(item) {
      return this.evaluation === item.value;
    },
    handleSubmit() {
      let message = '入力したメッセージを占い師に送ります。よろしいですか？';
      if (this.kaonashiFlg || this.is_digi) {
        message = '入力内容を送信します。よろしいですか？';
      }
      if (!this.comment_text) {
        message = 'メッセージが入力されていません。このまま送信しますか？';
      }

      // 確認メッセージでOKを選択した時にAPIにコメントを送信
      if (window.confirm(message)) {
        axios.post('/api/comments/create', this.postData).then(res => {
          if (res.status === 200) {
            this.hasPosted.evaluation = !!this.evaluation;
            this.hasPosted.comment_text = !!this.comment_text;
            this.$message({
              message: '送信が完了しました。',
              type: 'success'
            });
          }
        });
      }
    }
  }
};
</script>

<style lang="scss">
.caption {
  line-height: 1.26;
  font-size: 15px;
  text-align: center;
  font-family: 'a-otf-midashi-go-mb31-pr6n', sans-serif;
  color: rgba(20, 20, 20, 0.75);
}
.comment-content {
  font-family: 'Hiragino Kaku Gothic Pro';

  .comment-text {
    font-family: 'Hiragino Kaku Gothic Pro';
    line-height: 20px;
    font-size: 15px;
  }

  .notice {
    font-family: 'Hiragino Kaku Gothic Pro';
    line-height: 16px;
    font-size: 12px;
    color: #676767;
  }
}
.gray-line {
  border: 0px;
  border-top: 1px solid#EDEDED;
  margin: 0px;
}
.evaluationSelect {
  display: flex;
  justify-content: space-around;
  &__item {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    width: 96px;
    height: 32px;
    background: #ededed;
    border-radius: 3px;
    line-height: 14px;
    font-size: 14px;
    color: #676767;
    transition: 100ms ease-in-out;
    transition-property: background, color, font-weight;
    will-change: background, color, font-weight;
    @media screen and (max-width: 374px) {
      width: 88px;
    }

    &[data-selected='true'] {
      background: #ed1e79;
      color: #fff;
      font-weight: bold;
    }
  }
}
</style>



// WEBPACK FOOTER //
// ../../../../resources/assets/js/utvStore/components/CommentInput.vue